import type {
    ResolveCommerceCustomerIdentityRequest,
    ResolveCommerceCustomerIdentityResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";

export const resolveCommerceCustomerIdentityOperation = defineCommerceOperation<
    ResolveCommerceCustomerIdentityRequest,
    ResolveCommerceCustomerIdentityResponse
>("commerce.customer.identity.resolve");
